import styles from "./listing-card.module.css";
import Tippy from "@tippyjs/react";
import { useTranslations } from "next-intl";
import "tippy.js/dist/tippy.css";

export default function ListingCard({ activePlan }: { activePlan: string }) {
  const tier =
    activePlan === "essential" || activePlan === "plus" ? "basic" : "premium";
  const t = useTranslations("Pricing.ListingCard");
  return (
    <div
      className={`${styles.listingMock} ${styles[activePlan]} ${
        activePlan === "spotlight" ? styles.spotlight : ""
      }`}
    >
      <Tippy
        content={t(`image.${tier}`)}
        placement="top"
        theme="custom" // 👈 custom theme hook
      >
        <div className={styles.listingPhoto}></div>
      </Tippy>
      <div className={styles.content}>
        <div className={styles.mainContent}>
          {(activePlan === "prime" || activePlan === "spotlight") && (
            <Tippy
              content={t(`title`)}
              placement="top"
              theme="custom" // 👈 custom theme hook
              onShow={(instance) => {
                instance.reference.classList.add(styles.active); // 👈 add class for animation
              }}
              onHide={(instance) => {
                instance.reference.classList.remove(styles.active); // 👈 remove class
              }}
            >
              <div className={styles.title}></div>
            </Tippy>
          )}
          {(activePlan === "essential" || activePlan === "plus") && (
            <Tippy
              content={t(`title`)}
              placement="top"
              theme="custom" // 👈 custom theme hook
            >
              <div className={styles.titleWrapper}>
                <div className={styles.title1}></div>
                <div className={styles.title2}></div>
              </div>
            </Tippy>
          )}
          <Tippy
            content={t(`description`)}
            placement="top"
            theme="custom" // 👈 custom theme hook
          >
            <div className={styles.description}>
              <div className={styles.descriptionLine1}></div>
              <div className={styles.descriptionLine2}></div>
              <div className={styles.descriptionLine3}></div>
            </div>
          </Tippy>
          {(activePlan === "prime" || activePlan === "spotlight") && (
            <Tippy
              content={t(`features.premium`)}
              placement="top"
              theme="custom" // 👈 custom theme hook
            >
              <div className={styles.features}>
                <div className={styles.feature}></div>
                <div className={styles.featureSeparator}></div>
                <div className={styles.feature}></div>
                <div className={styles.featureSeparator}></div>
                <div className={styles.feature}></div>
                <div className={styles.featureSeparator}></div>
                <div className={styles.feature}></div>
                <div className={styles.featureSeparator}></div>
                <div className={styles.feature}></div>
              </div>
            </Tippy>
          )}
          {(activePlan === "essential" || activePlan === "plus") && (
            <Tippy
              content={t(`features.basic`)}
              placement="top"
              theme="custom" // 👈 custom theme hook
            >
              <div className={styles.featuresSimple}>
                <div className={styles.featuresRow}>
                  <div className={styles.feature}></div>
                  <div className={styles.featureSeparator}></div>
                  <div className={styles.feature}></div>
                </div>
                <div className={styles.featuresRow}>
                  <div className={styles.feature}></div>
                  <div className={styles.featureSeparator}></div>
                  <div className={styles.feature}></div>
                </div>
              </div>
            </Tippy>
          )}
          <Tippy
            content={t(`address`)}
            placement="top"
            theme="custom" // 👈 custom theme hook
          >
            <div className={styles.address}></div>
          </Tippy>
          {(activePlan === "plus" ||
            activePlan === "prime" ||
            activePlan === "spotlight") && (
            <>
              <Tippy
                content={t(`price`)}
                placement="top"
                theme="custom" // 👈 custom theme hook
              >
                <div className={styles.price}></div>
              </Tippy>
              <div className={styles.actions}>
                <div className={styles.userData}>
                  <Tippy
                    content={t("agentPhoto")}
                    placement="top"
                    theme="custom" // 👈 custom theme hook
                  >
                    <div className={styles.image}></div>
                  </Tippy>
                  <Tippy
                    content={t(`agentName`)}
                    placement="top"
                    theme="custom" // 👈 custom theme hook
                  >
                    <div className={styles.userName}></div>
                  </Tippy>
                </div>
                <div className={styles.buttonsWrapper}>
                  <Tippy
                    content={t(`favoriteButton`)}
                    placement="top"
                    theme="custom" // 👈 custom theme hook
                  >
                    <div className={styles.roundButton}></div>
                  </Tippy>
                  <Tippy
                    content={t(`contactButton`)}
                    placement="top"
                    theme="custom" // 👈 custom theme hook
                  >
                    <div className={styles.roundButton}></div>
                  </Tippy>
                </div>
              </div>
            </>
          )}
        </div>
        {activePlan === "essential" && (
          <div className={styles.actions}>
            <Tippy
              content={t(`price`)}
              placement="top"
              theme="custom" // 👈 custom theme hook
            >
              <div className={styles.price}></div>
            </Tippy>

            <div className={styles.buttonsWrapper}>
              <Tippy
                content={t(`favoriteButton`)}
                placement="top"
                theme="custom" // 👈 custom theme hook
              >
                <div className={styles.roundButton}></div>
              </Tippy>
              <Tippy
                content={t(`contactButton`)}
                placement="top"
                theme="custom" // 👈 custom theme hook
              >
                <div className={styles.roundButton}></div>
              </Tippy>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
